import React from "react";
import PropTypes from "prop-types";

import { LpgPlaySolid } from "@/icons";

import { Button } from "../Button";
import { Icon } from "../Icon";
import { A11yText } from "../A11yText";

import styles from "./VideoButton.scss";

export function VideoButton({ a11yText, variant, ...props }) {
  return (
    <Button variants={[Button.Variant.roundBoldOutline, variant]} {...props}>
      <Icon
        wrapperProps={{
          className: styles.icon,
        }}
        icon={LpgPlaySolid}
        size={Icon.Size.parent}
      />
      <A11yText>{a11yText}</A11yText>
    </Button>
  );
}

VideoButton.displayName = "VideoButton";

VideoButton.Variant = {
  large: styles.videoButtonLarge,
  medium: styles.videoButtonMedium,
  small: styles.videoButtonSmall,
};

VideoButton.propTypes = {
  a11yText: PropTypes.string,
  variant: PropTypes.string,
};

VideoButton.defaultProps = {
  a11yText: "Play",
  variant: VideoButton.Variant.medium,
};

export default VideoButton;
